import React from 'react';
import {Field2Groups} from "../../../../../gd/const/fields/field2-groups";

export default function Field2Icon(props:any) {

    const color = Field2Groups[props.field.typeGroup].color;

    return (
        <div className="details-big-icon">
            <div className={Classes("ui5-ico-custom-field s-72", props.field.icon, "bg-"+color)}/>
        </div>
    );
}
